var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiAdmin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.162 2.159c.213-.878 1.463-.878 1.676 0a.862.862 0 001.286.533c.771-.47 1.655.412 1.185 1.184a.862.862 0 00.533 1.286c.877.213.877 1.463 0 1.676a.862.862 0 00-.534 1.286c.47.771-.412 1.655-1.184 1.185a.862.862 0 00-1.287.533c-.212.877-1.462.877-1.675 0a.862.862 0 00-1.286-.534c-.772.47-1.655-.412-1.185-1.184a.862.862 0 00-.532-1.287c-.878-.212-.878-1.462 0-1.675a.862.862 0 00.533-1.286c-.47-.772.412-1.655 1.184-1.185a.861.861 0 001.286-.532z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--admin-42378a7362fe60d457da0d3b31da1976.svg";
export { SvgIconUiAdmin as Component };